// src/pages/Vehiculo.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function Vehiculo() {
  const [vehicles, setVehicles] = useState([]);
  const [showModal, setShowModal] = useState(false); // Controla la visibilidad del modal
  const API_URL = process.env.REACT_APP_API_URL;
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  // Estados para el formulario de nuevo vehículo
  const [marca, setMarca] = useState('');
  const [modelo, setModelo] = useState('');
  const [anio, setAnio] = useState('');
  const [precio, setPrecio] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [imagenes, setImagenes] = useState([]); // Para subir varias imágenes
  const [adultos, setAdultos] = useState('');
  const [ninos, setNinos] = useState('');
  const [vip, setVip] = useState(false);
  const [tarifaTipo, setTarifaTipo] = useState('dia');
  const API_URL_IMG = process.env.REACT_APP_API_URL_IMG_LT;

  // Estado para almacenar imágenes seleccionadas
  const [selectedImages, setSelectedImages] = useState([]);

  // Maneja los archivos cuando se seleccionan
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Conviertes FileList a array
    if (files.length > 0) {
      // Concatenamos los nuevos archivos a los que ya teníamos
      setSelectedImages((prev) => [...prev, ...files]);
    }
  };



  // Elimina una imagen del array
  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  // Cuando se envía el formulario
  const handleSubmit = (e) => {
    e.preventDefault();

    // Construimos el FormData
    const formData = new FormData();
    // Agregamos cada imagen
    selectedImages.forEach((file) => {
      formData.append('images[]', file);
    });
    // Agregamos los demás campos
    formData.append('marca', marca);
    formData.append('modelo', modelo);
    formData.append('anio', anio);
    formData.append('precio', precio);
    formData.append('tarifa_tipo', tarifaTipo);

    formData.append('descripcion', descripcion);

    formData.append('adultos', adultos);
    formData.append('ninos', ninos);
    formData.append('vip', vip ? 1 : 0); // envías 1 si está marcado, 0 si no


    // Petición POST con axios (multipart/form-data)
    axios
      .post(`${API_URL}vehicles`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        // Muestra SweetAlert2 de éxito
        Swal.fire({
          title: 'Creado',
          text: 'El vehículo se ha creado correctamente',
          icon: 'success',
          confirmButtonText: 'OK',
        });

        // Vuelvo a cargar la lista de vehículos
        return axios.get(`${API_URL}vehicles`);
      })
      .then((res) => {
        setVehicles(res.data); // Actualizo el estado con la nueva lista
        handleCloseModal(); // Cierro el modal
      })
      .catch((err) => {
        console.error('Error al crear vehículo:', err);
        // SweetAlert2 de error
        Swal.fire({
          title: 'Error',
          text: 'No se pudo crear el vehículo',
          icon: 'error',
        });
      });


  };


  useEffect(() => {
    axios
      .get(`${API_URL}vehicles`)
      .then((response) => {
        setVehicles(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener los vehículos:', error);
      });
  }, []);


  // Al hacer clic en el card de "+"
  const handleAddVehicleClick = () => {
    setSelectedVehicle(null); // esto indica que es nuevo
    setShowModal(true);
  };

  const handleViewDetails = (vehicle) => {
    setSelectedVehicle(vehicle); // modo visualización
    setShowModal(true);
  };



  // Cerrar el modal y limpiar campos si quieres
  const handleCloseModal = () => {
    setShowModal(false);
    // Opcional: limpiar campos
    setMarca('');
    setModelo('');
    setAnio('');
    setPrecio('');
    setDescripcion('');
    setAdultos('');
    setNinos('');
    setVip(false);

    setImagenes([]);
  };

  const handleDeleteVehicle = (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_URL}vehicles/${id}`)

          .then(() => {
            // Elimina del array local
            setVehicles((prev) => prev.filter((veh) => veh.id !== id));
            Swal.fire({
              title: 'Eliminado',
              text: 'El vehículo ha sido eliminado',
              icon: 'success'
            });
          })
          .catch((err) => {
            console.error('Error al eliminar vehículo:', err);
            Swal.fire({
              title: 'Error',
              text: 'No se pudo eliminar el vehículo',
              icon: 'error'
            });
          });
      }
    });
  };




  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <h4 className="pb-3">Nuestros Vehículos</h4>

      {/* Grid con cards */}
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
        {vehicles.map((vehicle) => (
          <div className="col" key={vehicle.id}>
            <div className="card h-100 shadow">

              {/* Si hay imágenes, mostramos el carousel; si no, un placeholder */}
              {vehicle.images && vehicle.images.length > 0 ? (
                <div
                  id={`carousel-${vehicle.id}`}       // un id único para cada carousel
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                  {vehicle.images.map((img, index) => {
  const url = `${API_URL_IMG}${img.image_path}`;
  console.log('🖼️ URL imagen vehículo:', url);

  return (
    <div
      className={`carousel-item ${index === 0 ? 'active' : ''}`}
      key={img.id}
    >
      <img
        src={url}
        className="d-block w-100"
        style={{ height: '200px', objectFit: 'cover' }}
        alt={`Vehículo-${vehicle.id}-img-${index}`}
      />
    </div>
  );
})}


                  </div>

                  {/* Controles anterior y siguiente (opcionales) */}
                  {vehicle.images.length > 1 && (
                    <>
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target={`#carousel-${vehicle.id}`}
                        data-bs-slide="prev"
                      >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target={`#carousel-${vehicle.id}`}
                        data-bs-slide="next"
                      >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </>
                  )}
                </div>
              ) : (
                // Si no hay imágenes
                <img
                  src="https://via.placeholder.com/400x200?text=No+Image"
                  alt="Sin imágenes"
                  className="card-img-top"
                  style={{ objectFit: 'cover', height: '200px' }}
                />
              )}

              {/* Resto de la card-body */}
              <div className="card-body d-flex flex-column">
                <h5 className="card-title mb-1">
                  {vehicle.marca} {vehicle.modelo}
                </h5>
                <p className="card-text fw-semibold">
                  Año: {vehicle.anio}
                  <br />
                  Precio: ${vehicle.precio}
                </p>
                <br />
Tarifa: {vehicle.tarifa_tipo === 'hora' ? 'Hora' : vehicle.tarifa_tipo === 'dia' ? 'Día' : 'KM Abierto'}

                <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                  {vehicle.descripcion}
                </p>

                {/* Contenedor para los botones al final */}
                <div className="mt-auto">
                  {/* Usamos d-flex para que ambos botones estén en la misma fila */}
                  <div className="d-flex align-items-center">
                    {/* flex-grow-1 hace que ocupe todo el espacio disponible */}
                    <button
                      className="btn btn-primary flex-grow-1 me-2"
                      onClick={() => handleViewDetails(vehicle)}
                    >
                      Ver detalles
                    </button>


                    <button
                      className="btn btn-danger"
                      onClick={() => handleDeleteVehicle(vehicle.id)}
                    >
                      <i className="bx bx-trash"></i>
                    </button>

                  </div>
                </div>
              </div>


            </div>
          </div>

        ))}

        {/* Card para "Añadir Vehículo" */}
        <div className="col">
          <div
            className="card shadow"
            style={{
              cursor: 'pointer',
              border: '2px dashed #0d6efd',
              backgroundColor: '#f8fbff',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={handleAddVehicleClick}
          >
            <div className="text-center">
              <h1 style={{ fontSize: '4rem', color: '#0d6efd' }}>+</h1>
              <h6 className="mt-2 text-primary">Añadir Vehículo</h6>
            </div>
          </div>
        </div>
      </div>

      {/* Modal para añadir nuevo vehículo (usando classes de Bootstrap 5) */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {selectedVehicle ? 'Detalles del Vehículo' : 'Agregar Nuevo Vehículo'}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>

                <div className="modal-body">
                  {/* Marca */}
                  <div className="mb-3">
                    <label className="form-label">Marca</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedVehicle ? selectedVehicle.marca : marca}
                      onChange={(e) => setMarca(e.target.value)}
                      readOnly={!!selectedVehicle}
                      required
                    />
                  </div>

                  {/* Modelo */}
                  <div className="mb-3">
                    <label className="form-label">Modelo</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedVehicle ? selectedVehicle.modelo : modelo}
                      onChange={(e) => setModelo(e.target.value)}
                      readOnly={!!selectedVehicle}
                      required
                    />
                  </div>

                  {/* Año */}
                  <div className="mb-3">
                    <label className="form-label">Año</label>
                    <input
                      type="number"
                      className="form-control"
                      value={selectedVehicle ? selectedVehicle.anio : anio}
                      onChange={(e) => setAnio(e.target.value)}
                      readOnly={!!selectedVehicle}
                      required
                    />
                  </div>

                  {/* Precio */}
                  <div className="mb-3">
                    <label className="form-label">Precio</label>
                    <input
                      type="number"
                      className="form-control"
                      value={selectedVehicle ? selectedVehicle.precio : precio}
                      onChange={(e) => setPrecio(e.target.value)}
                      readOnly={!!selectedVehicle}
                      required
                    />
                  </div>

                  <div className="mb-3">
  <label className="form-label">Tipo de tarifa</label>
  <select
    className="form-select"
    value={selectedVehicle ? selectedVehicle.tarifa_tipo : tarifaTipo}
    onChange={(e) => setTarifaTipo(e.target.value)}
    disabled={!!selectedVehicle}
    required
  >
    <option value="hora">Por hora</option>
    <option value="dia">Por día</option>
    <option value="km_abierto">Kilometraje abierto</option>
  </select>
</div>


                  {/* Descripción */}
                  <div className="mb-3">
                    <label className="form-label">Descripción</label>
                    <textarea
                      className="form-control"
                      rows={2}
                      value={selectedVehicle ? selectedVehicle.descripcion : descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                      readOnly={!!selectedVehicle}
                    ></textarea>
                  </div>

                  <div className="row">
                    {/* Número de Adultos */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Número de Adultos</label>
                      <input
                        type="number"
                        className="form-control"
                        value={selectedVehicle ? selectedVehicle.adultos : adultos}
                        onChange={(e) => setAdultos(e.target.value)}
                        readOnly={!!selectedVehicle}
                        required
                      />
                    </div>

                    {/* Número de Niños */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Número de Niños</label>
                      <input
                        type="number"
                        className="form-control"
                        value={selectedVehicle ? selectedVehicle.ninos : ninos}
                        onChange={(e) => setNinos(e.target.value)}
                        readOnly={!!selectedVehicle}
                        required
                      />
                    </div>
                  </div>

                  {/* Es VIP */}
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectedVehicle ? selectedVehicle.vip === 1 : vip}
                      onChange={(e) => setVip(e.target.checked)}
                      id="checkVip"
                      disabled={!!selectedVehicle}
                    />
                    <label className="form-check-label" htmlFor="checkVip">
                      ¿Vehículo VIP?
                    </label>
                  </div>

                  {/* Campo de carga de imágenes (solo si es nuevo) */}
                  {!selectedVehicle && (
                    <div className="mb-3">
                      <label className="form-label">Imágenes</label>
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        onChange={handleImageChange}
                      />
                    </div>
                  )}

                  {/* Previsualización de imágenes seleccionadas (nuevo vehículo) */}
                  {!selectedVehicle && selectedImages.length > 0 && (
                    <div className="row mt-2">
                      {selectedImages.map((file, index) => (
                        <div className="col-md-4 mb-3" key={index}>
                          <div className="card">
                            <div className="card-body p-2">
                              <img
                                src={URL.createObjectURL(file)}
                                alt="preview"
                                className="img-fluid"
                                style={{ height: '150px', objectFit: 'cover' }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-danger mt-2"
                                onClick={() => removeImage(index)}
                              >
                                Eliminar
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Galería de imágenes del vehículo seleccionado */}
                  {selectedVehicle && selectedVehicle.images?.length > 0 && (
                    <div className="row mt-2">
                      {selectedVehicle.images.map((img, index) => (
                        <div className="col-md-4 mb-3" key={index}>
                          <div className="card">
                            <div className="card-body p-2">
                              <img
                                src={`https://api.jsgraceinvestmentsllc.com/${img.image_path}`}
                                alt={`vehiculo-img-${index}`}
                                className="img-fluid"
                                style={{ height: '150px', objectFit: 'cover' }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Cerrar
                  </button>
                  {!selectedVehicle && (
                    <button type="submit" className="btn btn-primary">
                      Guardar
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>

        </div>
      )}

    </div>
  );
}

export default Vehiculo;
